import React from 'react';
import { StagedSourceBadge } from '../StagedSourceBadge';
import { useOrgFeatureFlag } from '../../hooks/useOrgFeatureFlags';
import type { Product } from '../../services/api';

type FieldSourceKey = keyof NonNullable<Product['fieldSources']>;

/**
 * Where a catalog field came from, as the admin staged review shows it, for the store
 * product details (flag `catalog_field_provenance`). Renders nothing with the flag off
 * or when the product carries no source for the field (never guessed).
 */
export function FieldSourceBadge({ product, field }: { product: Pick<Product, 'fieldSources'>; field: FieldSourceKey }) {
  const { enabled } = useOrgFeatureFlag('catalog_field_provenance');
  const entry = product.fieldSources?.[field];
  if (!enabled || !entry) return null;
  return <StagedSourceBadge source={entry} />;
}
